import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const NeighboursIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.49 4.63 12 8.904 7.51 4.629.323 11.265l1.356 1.47.322-.297v4.99a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4.99l.322.297 1.356-1.47zM20 10.591 16.51 7.37 13 10.714v5.715h7zm-9 .122L7.49 7.371 4 10.59v5.838h7z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
